import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/account/${number | ':accountId'}/rejectedEntries`;

export const ROUTE: RouteDefinition = `${baseRoute}/account/:accountId/rejectedEntries`;

export const URL = (accountId: number): RouteDefinition =>
	`${baseRoute}/account/${accountId}/rejectedEntries`;
